export const accent = '#8F1D13';
